import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Divider } from 'primeng/divider';

@Component({
  selector: 'app-about',
  imports: [Divider],
  templateUrl: '../ui/about.component.html',
  styleUrl: '../ui/about.component.css'
})
export class AboutComponent implements OnInit {
  private readonly _ticketService = inject(Title)

  ngOnInit(): void {
    this._ticketService.setTitle('LRPTickets.co.uk | About')
  }
}
